import styled, { keyframes } from "styled-components";
import banner from "../../assets/TACA-icon.png";
export const StyledSupport = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: rgba(41, 169, 225, 0.07);
    width: 100%;
    padding: 2rem 0rem 2rem 0vw;
  `,
  TacaLogo = styled.div`
    width: 100%;
    display: flex;
    height: 7rem;
    z-index: 1;
    flex-flow: column;
    justify-content: flex-end;
    background: url(${banner}) no-repeat center;
    margin: 0;
    overflow: visible;
    @media only screen and (min-width: 600px) {
      display:none;
    }
  `,
  BoldText = styled.h1`
    font-size: 18px;
    font-weight: 600;
    padding: 0.5rem 0rem;
    color: #083f88;
    text-align: center;
    @media only screen and (min-width: 600px) {
      font-size: 20px;
    }
    @media only screen and (min-width: 725px) {
      font-size: 24px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 2.4vw;
    }
  `,
  SubText = styled.p`
    font-weight: 400;
    padding: 1vw;
    text-align: center;
    font-size: 12px;
    width: 70%;
    color: #083F88;
    letter-spacing: 0.1px;
    @media only screen and (min-width: 350px) {
      font-size: 15px;
      line-height: 1.3;
    }
    @media only screen and (min-width: 500px) {
      padding-bottom: 1.5rem;
      &:nth-of-type(1) {
        padding-bottom: 0;
      }
    }

    @media only screen and (min-width: 725px) {
      font-size: 15px;
      width: calc(100% - 2vw);
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.1vw;
    }
  `,
  Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `,
  slideLeft = keyframes`
0%{transform:translateX(100%);opacity:0;}
70%{opacity:0.1;}
100%{transform:translateX(0%);opacity:1;}
`,
  SupportBox = styled.div`
    display: ${({ supportAni }) => (supportAni ? "flex" : "none")};
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 0rem 0rem 1rem 0rem;
    height: 100%;
    overflow: hidden;
    animation: ${slideLeft} 0.5s linear 0s 1;
    @media only screen and (min-width: 600px) {
      height: 18.5rem;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    @media only screen and (min-width: 725px) {
      height: 20rem;
    }
    @media only screen and (min-width: 1000px) {
      height: 28vw;
    }
  `,
  StandIn = styled.div`
    opacity: 0;
  `,
  People = styled.img`
    height: 100%;
    margin: 0;
    border-radius: 0;
    width: 90%;
    @media only screen and (min-width: 600px) {
      height: 100%;
      width: 20rem;
      margin-left: 2vw;
      border-radius: 10px 0px 0px 10px;
    }
    @media only screen and (min-width: 1000px) {
      height: 100%;
      width: 35vw;
      margin-left: 2vw;
      border-radius: 10px 0px 0px 10px;
    }
  `,
  TextColumn = styled.div`
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0rem;
    width: 100%;
    border-radius: 0px 0px 10px 10px;

    @media only screen and (min-width: 600px) {
      border-radius: 0px 10px 10px 0px;
      justify-content: center;
      align-items: flex-start;
      width: 20rem;
      padding: 0vw 2vw;
    }
    @media only screen and (min-width: 725px) {
      width: 22rem;
    }
    @media only screen and (min-width: 1000px) {
      width: 32vw;
    }
  `,
  Text = styled.h6`
    font-size: 15px;
    line-height: 1.8;
    padding: 1vw 0vw 1vw 0vw;
    text-align: center;
    font-weight: 400;
    width: 90%;
    color: #222222;
    z-index: 1;
    @media only screen and (min-width: 500px) {
      font-size: 13px;
    }
    @media only screen and (min-width: 600px) {
      padding: 0vw 0vw 0.5vw 0vw;
      text-align: left;
      font-size: 14px;
      line-height: 1;
    }
    @media only screen and (min-width: 800px) {
      font-size: 15px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.15vw;
    }
    @media only screen and (max-width: 575px) {
      margin-top: 10px;
    }
  `,
  ButtonBox = styled.div`
    padding: 1rem 1rem;
    @media only screen and (min-width: 500px) {
      padding: 1rem 0vw;
    }
  `,
  Link = styled.a`
    text-decoration: none;
    color: #00a7d9;
    transition: color 0.4s;
    &:hover {
      color: #083f88;
    }
    &:visted {
      color: #083f88;
    }
  `;
